/* =========================================================================
   Nolyae — Panier tiroir : upsell + code promo
   Listeners DÉLÉGUÉS sur document : le contenu du drawer est re-rendu (innerHTML
   remplacé) à chaque changement panier, donc on ne peut pas binder les éléments
   directement. On délègue depuis document, qui persiste.
   ========================================================================= */
(function () {
  'use strict';

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }
  function addUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }

  // Re-render du drawer à partir de la section cart-drawer (mirroir de
  // CartItems.onCartUpdate) — utilisé après application d'un code promo.
  function refreshDrawerSection() {
    return fetch(cartUrl() + '?section_id=cart-drawer')
      .then((r) => r.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        ['cart-drawer-items', '.cart-drawer__footer'].forEach((selector) => {
          const target = document.querySelector(selector);
          const source = html.querySelector(selector);
          if (target && source) target.replaceWith(source);
        });
      });
  }

  /* ---- Upsell : ajout au panier + re-render complet du drawer ---------- */
  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-nolyae-upsell-add]');
    if (!btn) return;
    event.preventDefault();

    const variantId = btn.getAttribute('data-nolyae-upsell-add');
    if (!variantId) return;

    btn.classList.add('is-loading');

    fetch(addUrl() + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    })
      .then((r) => r.json())
      .then((data) => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && data && data.sections && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data);
        }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'nolyae-cart-upsell' });
        }
      })
      .catch(function () {
        /* silencieux : l'upsell reste utilisable */
      })
      .finally(function () {
        btn.classList.remove('is-loading');
      });
  });

  /* ---- Carrousel upsell : flèches ‹ › --------------------------------- */
  document.addEventListener('click', function (event) {
    const prev = event.target.closest('[data-nolyae-upsell-prev]');
    const next = event.target.closest('[data-nolyae-upsell-next]');
    if (!prev && !next) return;
    event.preventDefault();
    const wrap = (prev || next).closest('[data-nolyae-upsell]');
    const track = wrap && wrap.querySelector('[data-nolyae-upsell-track]');
    if (!track) return;
    const amount = Math.max(track.clientWidth * 0.8, 160);
    track.scrollBy({ left: next ? amount : -amount, behavior: 'smooth' });
  });

  /* ---- Code promo : applique via /discount/CODE puis re-render --------- */
  document.addEventListener('submit', function (event) {
    const form = event.target.closest('#nolyae-cart-discount-form');
    if (!form) return;
    event.preventDefault();

    const input = form.querySelector('input[name="discount"]');
    const msg = form.querySelector('.nolyae-cart__promo-msg');
    const code = input ? input.value.trim() : '';
    if (!code) return;

    form.classList.add('is-loading');
    if (msg) {
      msg.textContent = '';
      msg.classList.remove('is-error', 'is-ok');
    }

    // Total avant application, pour détecter si le code a changé quelque chose.
    fetch(cartUrl() + '.js')
      .then((r) => r.json())
      .then((before) => {
        const totalBefore = before ? before.total_price : null;
        return fetch('/discount/' + encodeURIComponent(code), { method: 'GET' })
          .then(function () {
            return refreshDrawerSection();
          })
          .then(function () {
            return fetch(cartUrl() + '.js').then((r) => r.json());
          })
          .then(function (after) {
            const applied =
              after &&
              ((after.cart_level_discount_applications &&
                after.cart_level_discount_applications.length > 0) ||
                (totalBefore !== null && after.total_price < totalBefore));
            if (msg) {
              if (applied) {
                msg.textContent = 'Code appliqué ✓';
                msg.classList.add('is-ok');
                if (input) input.value = '';
              } else {
                msg.textContent = 'Code invalide ou non applicable.';
                msg.classList.add('is-error');
              }
            }
          });
      })
      .catch(function () {
        if (msg) {
          msg.textContent = 'Une erreur est survenue, réessaie.';
          msg.classList.add('is-error');
        }
      })
      .finally(function () {
        form.classList.remove('is-loading');
      });
  });
})();
